module.exports = __webpack_public_path__ + "static/img/shouye.c9410609.jpg";